/* elv-set-picker.js — 2026-10-17. One engine for the two band pickers:
     mode "band"   : a band page. The page's band is fixed; tapping other colours ADDS them to a set.
     mode "device" : a WHOOP tracker page. The included band is fixed; tapping bands adds them to the tracker.
   Every saving shown mirrors a live automatic discount (checked in the admin 2026-10-17, no end dates):
     bands alone : any 2 bands/accessories 10% off both, any 3+ 15% off all (Basic, min quantity)
     with tracker: +1 band 5% off it, +2 bands 10% off both, +3 15% (Bxgy) — and the "any 3+ 15% off all"
                   Basic discount covers a 4th, 5th band, so 3+ is 15% on every band. Best one wins, never stacked.
   The set is sent as separate cart lines; the cart then shows the same discount applied. */
(function () {
  'use strict';
  function money(c) { return 'EGP ' + Math.round(c / 100).toLocaleString('en-US'); }
  /* 2026-10-17: the cart counts. tierOf() = accessories / trackers ALREADY in the cart (elv-cart-tier.js);
     band page: this band + picks + cart accessories, trackers = cart trackers;
     device page: picks + cart accessories, trackers = this device + cart trackers.
     accessories: 2 -> 10%, 3+ -> 15%; with a tracker 1 -> 5% (the live automatic discounts). */
  function tierOf() { var t = window.elvTier || {}; return { acc: +t.acc || 0, trk: +t.trk || 0, accSum: +t.accSum || 0 }; }
  function accPct(nAcc, nTrk) { if (nTrk >= 1) { return nAcc >= 2 ? 15 : (nAcc === 1 ? 10 : 0); } return nAcc >= 3 ? 15 : (nAcc === 2 ? 10 : 0); }
  /* Shopify keeps ONE automatic discount, the one saving more: a tracker pair (EGP 499 each) can beat a small band
     saving. sum = the page's set prices (cents), so the comparison uses real money. */
  function pctFor(mode, n, sum) {
    var c = tierOf(), nAcc = n + c.acc, nTrk = c.trk + (mode === 'band' ? 0 : 1), accSum = c.accSum + (sum || 0);
    var pct = accPct(nAcc, nTrk);
    if (window.elvTierFns && window.elvTierFns.best) { return window.elvTierFns.best(nAcc, nTrk, accSum).pct; }
    return pct;
  }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function init(root) {
    document.documentElement.classList.add('elp-page');
    if (root.dataset.init) { return; }
    root.dataset.init = '1';
    var mode = root.getAttribute('data-mode') || 'band';
    var T = {};
    try { T = JSON.parse(root.querySelector('.elp-i18n').textContent); } catch (e) {}
    var anchorVid = (root.getAttribute('data-anchor-vid') || '').trim();
    var anchorPrice = parseInt(root.getAttribute('data-anchor-price'), 10) || 0;
    var fixedBtn = root.querySelector('.elp-self .wbp-band, .wbp-band.wbp-incl');
    var nameEl = root.querySelector('.elp-name'), xEl = root.querySelector('.elp-x');
    var defaultName = nameEl ? nameEl.innerHTML : '', defaultX = xEl ? xEl.innerHTML : '';
    var setBox = root.querySelector('.elp-set'), linesEl = root.querySelector('.elp-lines');
    var totOld = root.querySelector('.elp-tot-old'), totNew = root.querySelector('.elp-tot-new'), totSave = root.querySelector('.elp-tot-save');
    var nudge = root.querySelector('.elp-nudge'), shipNote = root.querySelector('.elp-ships');
    var steps = root.querySelectorAll('.elp-ladder li');
    var order = [], sel = {}, hovered = null;
    var ladder = root.querySelector('.elp-ladder'), ind = null, lastTier = -1;
    var cartLine = document.createElement('p'); cartLine.className = 'elp-cart'; cartLine.hidden = true;
    if (ladder) { ladder.insertAdjacentElement('afterend', cartLine); }
    function cartLineText(pct) {
      var c = tierOf(), s = '';
      if (mode === 'band') {
        if (c.acc >= 1) { s = (c.acc === 1 ? (T.cartAcc1 || '1 band in your cart counts — add this one and both are −{p}%') : (T.cartAcc || '{a} in your cart count — add this one and all are −{p}%')).replace('{a}', c.acc + ' ' + (T.bandN || 'bands')).replace('{p}', pct); }
        else if (c.trk >= 1) { s = (T.cartTrk || 'Tracker in your cart — this band is −{p}%').replace('{p}', pct); }
      } else if (c.acc >= 1) { s = (T.cartAccDev || '{a} in your cart already count toward the discount').replace('{a}', c.acc + ' ' + (c.acc === 1 ? (T.band1 || 'band') : (T.bandN || 'bands'))); }
      return s;
    }
    function rungOne() {
      if (!ladder) { return; }
      var l1 = ladder.querySelector('li[data-n="1"] b'), l2 = ladder.querySelector('li[data-n="2"] b');
      var withTrk = mode === 'device' || tierOf().trk >= 1;
      if (l1) { if (!l1.dataset.orig) { l1.dataset.orig = l1.textContent; } l1.textContent = withTrk ? '−10%' : l1.dataset.orig; l1.setAttribute('dir', 'ltr'); }
      if (l2) { if (!l2.dataset.orig) { l2.dataset.orig = l2.textContent; } l2.textContent = withTrk ? '−15%' : l2.dataset.orig; l2.setAttribute('dir', 'ltr'); }
    }
    if (ladder) { ind = document.createElement('span'); ind.className = 'elp-ind'; ind.setAttribute('aria-hidden', 'true'); ladder.insertBefore(ind, ladder.firstChild); }
    function moveInd(tier) {
      if (!ind) { return; }
      var li = ladder.querySelector('li[data-n="' + tier + '"]');
      if (!li) { ind.style.opacity = '0'; return; }
      ind.style.opacity = '1';
      ind.style.width = li.offsetWidth + 'px';
      ind.style.transform = 'translateX(' + li.offsetLeft + 'px)';
      if (tier !== lastTier && lastTier !== -1) {
        var bb = li.querySelector('b'); if (bb) { bb.classList.remove('elp-pop'); void bb.offsetWidth; bb.classList.add('elp-pop'); }
      }
      lastTier = tier;
    }
    var rzT = 0;
    window.addEventListener('resize', function () { clearTimeout(rzT); rzT = setTimeout(function () { if (lastTier > 0) { moveInd(lastTier); } }, 150); });

    /* Phones: a slim bar fixed to the bottom while the picker is on screen — the set's photos, its old and new
       total, and the add button — so choosing colours, seeing the photo and seeing the saving happen on ONE screen. */
    var dock = document.createElement('div');
    dock.className = 'elp-dock'; dock.hidden = true;
    if (root.getAttribute('dir')) { dock.setAttribute('dir', root.getAttribute('dir')); }
    dock.innerHTML = '<span class="elp-dock-th"></span><span class="elp-dock-t"><span class="elp-dock-n"></span>' +
      '<span class="elp-dock-p"><s dir="ltr"></s> <b dir="ltr"></b></span></span><button type="button" class="elp-dock-btn"></button>';
    document.body.appendChild(dock);
    var inView = false, isActive = false, addVisible = false;
    /* shown while a set is chosen, anywhere on the page, except when the real Add-to-cart button is itself on screen */
    var dockOn = null, mqPhone = window.matchMedia('(max-width: 749px)');
    function dockShow() {
      var on = mqPhone.matches;
      if (on === dockOn) { return; }
      dockOn = on; dock.hidden = !on; document.documentElement.classList.toggle('elp-dock-on', on);
    }
    dock.querySelector('.elp-dock-btn').addEventListener('click', function () {
      var rb = document.querySelector('.product__info-container product-form [name="add"]') || document.querySelector('product-form [name="add"]');
      if (!rb) { return; }
      /* submit the form directly: a click on a button that is mid-re-render can be swallowed */
      var f = rb.form || rb.closest('form');
      if (f && f.requestSubmit) { f.requestSubmit(rb); } else { rb.click(); }
    });

    /* ---------- hero photo preview (same approach the device picker has used since v10) ---------- */
    var hero = null, heroOrig = null;
    function getHero() {
      return document.querySelector('.product__media-list li.is-active .product__media img') ||
        document.querySelector('.product__media-list .product__media img') || document.querySelector('media-gallery img');
    }
    function setHero(url) {
      if (!url) { return; }
      hero = hero || getHero(); if (!hero) { return; }
      if (heroOrig === null) {
        var p0 = hero.closest('picture');
        heroOrig = { src: hero.getAttribute('src'), srcset: hero.getAttribute('srcset'),
          sources: p0 ? Array.prototype.map.call(p0.querySelectorAll('source'), function (s) { return { el: s, srcset: s.getAttribute('srcset') }; }) : [] };
      }
      heroOrig.sources.forEach(function (o) { o.el.removeAttribute('srcset'); });
      hero.removeAttribute('srcset'); hero.setAttribute('src', url);
    }
    function restoreHero() {
      if (!hero || heroOrig === null) { return; }
      heroOrig.sources.forEach(function (o) { if (o.srcset === null) { o.el.removeAttribute('srcset'); } else { o.el.setAttribute('srcset', o.srcset); } });
      if (heroOrig.srcset === null) { hero.removeAttribute('srcset'); } else { hero.setAttribute('srcset', heroOrig.srcset); }
      hero.setAttribute('src', heroOrig.src);
    }
    var shown = '';
    function showImg(url) { var key = url || ''; if (key === shown) { return; } shown = key; if (url) { setHero(url); } else { restoreHero(); } }

    /* ---------- the "Colour: …" label: name, price, Pre-order pill. No link: the photo already shows it ---------- */
    function label(b) {
      if (!nameEl) { return; }
      if (!b || b === fixedBtn) { nameEl.innerHTML = defaultName; if (xEl) { xEl.innerHTML = defaultX; } return; }
      var nm = esc(b.getAttribute('data-name'));
      if (mode === 'device' || otherFam(b)) { nm = esc(b.getAttribute('data-fam')) + ' · ' + nm; }
      nameEl.innerHTML = nm;
      var price = parseInt(b.getAttribute('data-price'), 10) || 0;
      /* 2026-10-17 owner: show the normal price as a sale and the set price beside it. A band already in the set is
         priced at the set's current rung; one being looked at is priced at the rung it would bring the set to. */
      var k0 = order.length, isIn = sel[b.getAttribute('data-vid')] !== undefined;
      var nIf = mode === 'band' ? (isIn ? k0 + 1 : k0 + 2) : (isIn ? k0 : k0 + 1);
      var pIf = pctFor(mode, nIf), nw = Math.round(price * (100 - pIf) / 100);
      var s = pIf > 0
        ? ' <span class="elp-xs"><s dir="ltr">' + Math.round(price / 100).toLocaleString('en-US') + '</s> <b dir="ltr">' + money(nw) + '</b> <em dir="ltr">−' + pIf + '%</em></span>'
        : ' <span class="elp-xp" dir="ltr">' + money(price) + '</span>';
      if (b.getAttribute('data-pre') === 'true') { s += ' <span class="elp-po">' + esc(T.pre) + '</span>'; }
      if (xEl) { xEl.innerHTML = s; }
    }
    function otherFam(b) { return mode === 'band' && fixedBtn && b !== fixedBtn && b.getAttribute('data-fam') !== fixedBtn.getAttribute('data-fam'); }
    function lastBtn() { return order.length ? sel[order[order.length - 1]].el : null; }

    /* ---------- main price on a band page: struck + the set price, so the saving sits next to the photo ---------- */
    var info = root.closest('.product__info-container') || document;
    var priceBlock = mode === 'band' ? info.querySelector('[id^="price-"] .price') : null;
    var mainSet = null;
    if (priceBlock) {
      mainSet = document.createElement('span');
      mainSet.className = 'elp-mp'; mainSet.hidden = true;
      priceBlock.appendChild(mainSet);
    }

    function thumb(b) {
      var bg = (b.getAttribute('data-bg') || '').split(' ');
      var size = bg.shift() || 'cover', pos = bg.join(' ') || 'center';
      return '<span class="elp-th" style="--dot:' + esc(b.getAttribute('data-hex') || '#ddd') + ';background-image:url(\'' +
        esc(b.getAttribute('data-sw')) + '\');background-size:' + esc(size) + ';background-position:' + esc(pos) + '"></span>';
    }
    function line(b, price, pct, fixed) {
      var nw = Math.round(price * (100 - pct) / 100);
      var nm = esc(b.getAttribute('data-name'));
      if (mode === 'device' || otherFam(b)) { nm = '<small>' + esc(b.getAttribute('data-fam')) + '</small> ' + nm; }
      var pre = b.getAttribute('data-pre') === 'true' ? ' <span class="elp-po">' + esc(T.pre) + '</span>' : '';
      var tag = fixed ? ' <span class="elp-this">' + esc(T.thisBand) + '</span>' : '';
      var pr = pct > 0 ? '<s dir="ltr">' + Math.round(price / 100).toLocaleString('en-US') + '</s> <b dir="ltr">' + money(nw) + '</b>' : '<b dir="ltr">' + money(price) + '</b>';
      var rm = fixed ? '<span class="elp-rm-sp"></span>' : '<button type="button" class="elp-rm" data-rm="' + esc(b.getAttribute('data-vid')) + '" aria-label="' + esc(T.remove) + '">×</button>';
      return '<li class="elp-line">' + thumb(b) + '<span class="elp-ln">' + nm + tag + pre + '</span><span class="elp-lp">' + pr + '</span>' + rm + '</li>';
    }

    function refresh() {
      var k = order.length, n = mode === 'band' ? k + 1 : k, i, setSum = mode === 'band' ? anchorPrice : 0;
      for (i = 0; i < k; i++) { setSum += sel[order[i]].price; }
      var pct = pctFor(mode, n, setSum), html = '', oldSum = 0, newSum = 0, anyPre = false;
      if (mode === 'band' && fixedBtn) {
        html += line(fixedBtn, anchorPrice, pct, true);
        oldSum += anchorPrice; newSum += Math.round(anchorPrice * (100 - pct) / 100);
        if (fixedBtn.getAttribute('data-pre') === 'true') { anyPre = true; }
      }
      for (i = 0; i < k; i++) {
        var it = sel[order[i]];
        html += line(it.el, it.price, pct, false);
        oldSum += it.price; newSum += Math.round(it.price * (100 - pct) / 100);
        if (it.el.getAttribute('data-pre') === 'true') { anyPre = true; }
      }
      var ct = tierOf(), nAll = n + ct.acc;
      var active = mode === 'band' ? (n >= 2 || pct > 0) : k >= 1;
      if (mode === 'device') { oldSum += anchorPrice; newSum += anchorPrice; }
      if (linesEl) { linesEl.innerHTML = html; }
      if (setBox) { setBox.hidden = !active; }
      if (shipNote) { shipNote.hidden = !(active && anyPre); }
      if (totOld) { totOld.textContent = oldSum > newSum ? money(oldSum) : ''; }
      if (totNew) { totNew.textContent = money(newSum); }
      if (totSave) { totSave.textContent = oldSum > newSum ? (T.save + ' ' + money(oldSum - newSum) + ' (' + pct + '%)') : ''; }
      /* ladder: the rung you are on, and the next one to reach */
      var tier = Math.min(nAll, 3);
      for (i = 0; i < steps.length; i++) {
        var sn = parseInt(steps[i].getAttribute('data-n'), 10);
        steps[i].classList.toggle('is-on', sn === tier);
        steps[i].classList.toggle('is-past', sn < tier);
        steps[i].classList.toggle('is-next', sn === tier + 1);
      }
      rungOne(); moveInd(tier);
      var clt = pct > 0 ? cartLineText(pct) : ''; cartLine.textContent = clt; cartLine.hidden = !clt;
      if (nudge) {
        var withT = mode === 'device' || ct.trk >= 1;
        var nx = withT ? (nAll === 0 ? T.n0 : (nAll === 1 ? (T.n1t || T.n1) : T.n3)) : (nAll === 1 ? T.n1 : (nAll === 2 ? T.n2 : T.n3));
        nudge.innerHTML = nx || ''; nudge.hidden = !nx;
      }
      if (mode === 'band') {
        var pb = info.querySelector('[id^="price-"] .price');
        if (pb && pb !== priceBlock) { priceBlock = pb; if (!mainSet) { mainSet = document.createElement('span'); mainSet.className = 'elp-mp'; mainSet.hidden = true; } priceBlock.appendChild(mainSet); }
      }
      if (mainSet && priceBlock) {
        if (active && pct > 0) {
          mainSet.innerHTML = '<bdi dir="ltr">' + money(Math.round(anchorPrice * (100 - pct) / 100)) + '</bdi> <em dir="' + (root.getAttribute('dir') || 'ltr') + '"><bdi dir="ltr">−' + pct + '%</bdi> ' + esc(k === 0 && ct.acc + ct.trk > 0 ? (T.withCart || 'with your cart') : T.inSet) + '</em>';
          mainSet.hidden = false; priceBlock.classList.add('elp-struck');
        } else { mainSet.hidden = true; priceBlock.classList.remove('elp-struck'); }
      }
      isActive = active;
      if (!active || (mode === 'band' && k === 0)) {
        dock.querySelector('.elp-dock-th').innerHTML = (mode === 'band' && fixedBtn) ? thumb(fixedBtn) : '';
        var p0 = mode === 'band' ? pct : 0;
        dock.querySelector('.elp-dock-n').innerHTML = '<span>' + esc(mode === 'band' ? (T.one || '1 band') : (T.incl1 || 'Band included')) + '</span>' +
          (p0 ? '<em dir="ltr">−' + p0 + '%</em><s class="elp-dock-was" dir="ltr">' + Math.round(anchorPrice / 100).toLocaleString('en-US') + '</s>' : '');
        dock.querySelector('.elp-dock-p b').textContent = money(Math.round(anchorPrice * (100 - p0) / 100));
        dock.querySelector('.elp-dock-btn').textContent = T.addCart || 'Add to cart';
      } else {
        var thHtml = '', list = mode === 'band' && fixedBtn ? [fixedBtn] : [];
        for (i = 0; i < k; i++) { list.push(sel[order[i]].el); }
        for (i = 0; i < Math.min(list.length, 3); i++) { thHtml += thumb(list[i]); }
        if (list.length > 3) { thHtml += '<span class="elp-th elp-th-more" dir="ltr">+' + (list.length - 3) + '</span>'; }
        dock.querySelector('.elp-dock-th').innerHTML = thHtml;
        var cnt = mode === 'band' ? n : k;
        dock.querySelector('.elp-dock-n').innerHTML = '<span>' + esc(((cnt === 1 && T.bands1) ? T.bands1 : (T.bandsN || '{n} bands')).replace('{n}', cnt)) + '</span>' + (pct ? '<em dir="ltr">−' + pct + '%</em>' : '') +
          (oldSum > newSum ? '<s class="elp-dock-was" dir="ltr">' + Math.round(oldSum / 100).toLocaleString('en-US') + '</s>' : '');
        dock.querySelector('.elp-dock-p s').textContent = oldSum > newSum ? Math.round(oldSum / 100).toLocaleString('en-US') : '';
        dock.querySelector('.elp-dock-p b').textContent = money(newSum);
        dock.querySelector('.elp-dock-btn').textContent = mode === 'band' ? (T.addSet || 'Add {n} bands').replace('{n}', cnt) : (T.addAll || 'Add to cart');
      }
      dockShow();
      if (typeof chipCounts === 'function') { chipCounts(); }
      /* the sticky buy bar reads these */
      if (active) { root.setAttribute('data-total', money(newSum)); root.setAttribute('data-count', String(mode === 'band' ? n : k)); }
      else { root.removeAttribute('data-total'); root.removeAttribute('data-count'); }
      var pay = document.querySelectorAll('.shopify-payment-button');
      for (i = 0; i < pay.length; i++) { pay[i].style.display = k > 0 ? 'none' : ''; }
      document.dispatchEvent(new CustomEvent('elp:change', { detail: { count: n, total: newSum } }));
    }

    function toggle(b) {
      var vid = b.getAttribute('data-vid');
      if (sel[vid] !== undefined) {
        delete sel[vid]; var ix = order.indexOf(vid); if (ix > -1) { order.splice(ix, 1); }
        b.classList.remove('is-sel'); b.setAttribute('aria-pressed', 'false');
      } else {
        sel[vid] = { price: parseInt(b.getAttribute('data-price'), 10) || 0, img: b.getAttribute('data-img'), el: b };
        order.push(vid); b.classList.add('is-sel'); b.setAttribute('aria-pressed', 'true');
      }
      var lb = lastBtn();
      showImg(lb ? lb.getAttribute('data-img') : null); label(lb); refresh();
    }

    var btns = root.querySelectorAll('.wbp-band');
    Array.prototype.forEach.call(btns, function (b) {
      var fixed = b === fixedBtn;
      if (fixed) { b.setAttribute('aria-pressed', 'true'); b.classList.add('is-fixed'); }
      b.addEventListener('mouseenter', function () { if (hovered === b) { return; } hovered = b; if (!fixed) { showImg(b.getAttribute('data-img')); label(b); } });
      b.addEventListener('mouseleave', function () { if (hovered !== b) { return; } hovered = null; var lb = lastBtn(); showImg(lb ? lb.getAttribute('data-img') : null); label(lb); });
      b.addEventListener('focus', function () { if (!fixed) { showImg(b.getAttribute('data-img')); label(b); } });
      b.addEventListener('blur', function () { var lb = lastBtn(); showImg(lb ? lb.getAttribute('data-img') : null); label(lb); });
      b.addEventListener('click', function () { if (fixed) { showImg(b.getAttribute('data-img')); label(null); return; } toggle(b); });
    });
    root.addEventListener('click', function (e) {
      var rm = e.target.closest && e.target.closest('[data-rm]');
      if (!rm) { return; }
      var b = root.querySelector('.wbp-band[data-vid="' + rm.getAttribute('data-rm') + '"]');
      if (b) { toggle(b); }
    });

    /* Pre-order group: one line with its count; opens on tap. A chosen pre-order band stays chosen when closed. */
    Array.prototype.forEach.call(root.querySelectorAll('.elp-more'), function (mb) {
      var g = document.getElementById(mb.getAttribute('aria-controls'));
      mb.addEventListener('click', function () {
        var open = mb.getAttribute('aria-expanded') === 'true';
        mb.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (g) { g.hidden = open; }
      });
    });
    var chips = root.querySelectorAll('.elp-chip');
    Array.prototype.forEach.call(chips, function (ch) {
      ch.addEventListener('click', function () {
        var open = ch.getAttribute('aria-expanded') === 'true';
        Array.prototype.forEach.call(chips, function (o) {
          o.setAttribute('aria-expanded', 'false');
          var g0 = document.getElementById(o.getAttribute('aria-controls')); if (g0) { g0.hidden = true; }
        });
        if (!open) {
          ch.setAttribute('aria-expanded', 'true');
          var g = document.getElementById(ch.getAttribute('aria-controls'));
          if (g) { g.hidden = false; }
        }
      });
    });
    function chipCounts() {
      Array.prototype.forEach.call(chips, function (ch) {
        var g = document.getElementById(ch.getAttribute('aria-controls')), c = g ? g.querySelectorAll('.wbp-band.is-sel').length : 0;
        var el = ch.querySelector('.elp-chip-c'); if (el) { el.textContent = '+' + c; el.hidden = c === 0; }
        ch.classList.toggle('has-sel', c > 0);
      });
    }
    /* Long ready-to-ship grids (tracker pages carry ~26): first two rows, then a "+N" tile that opens the rest. */
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 0;
    if (limit) {
      var rg = root.querySelector('.elp-grid--ready');
      var cells = rg ? rg.querySelectorAll(':scope > .wbp-band, :scope > .elp-self') : [];
      if (cells.length > limit + 1) {
        for (var c = limit; c < cells.length; c++) { cells[c].classList.add('elp-over'); }
        var more = document.createElement('button');
        more.type = 'button'; more.className = 'elp-plus';
        more.innerHTML = '<span>+' + (cells.length - limit) + '</span>';
        more.setAttribute('aria-label', (T.showAll || 'Show all') + ' (' + cells.length + ')');
        more.addEventListener('click', function () { rg.classList.add('is-all'); more.remove(); });
        rg.appendChild(more);
      }
    }

    /* The extra lines for the current set, in the size chosen on the page (Garmin S–M / L–XL). Also read by the
       Elvara Care add-on (snippets/elvara-care-addon.liquid), which adds the plan together with the set. */
    function extraItems() {
      var box = root.closest('.product__info-container') || document, vt = null, out = [], i;
      try { var sv = box.querySelector('[data-selected-variant]'); if (sv) { vt = (JSON.parse(sv.textContent) || {}).title || null; } } catch (err) {}
      for (i = 0; i < order.length; i++) {
        var vid = parseInt(order[i], 10), vm = sel[order[i]].el.getAttribute('data-vmap');
        if (vm && vt) { try { var m = JSON.parse(vm); if (m[vt]) { vid = m[vt]; } } catch (err2) {} }
        out.push({ id: vid, quantity: 1 });
      }
      return out;
    }
    window.elpExtraItems = extraItems;
    function qtyFor(form) {
      /* Dawn keeps the quantity box OUTSIDE the form (form="…"), so look it up by the form's id first */
      var q = form.querySelector('[name="quantity"]') || (form.id && document.querySelector('input[name="quantity"][form="' + form.id + '"]')) ||
        document.querySelector('.product__info-container input[name="quantity"]');
      return q ? (parseInt(q.value, 10) || 1) : 1;
    }
    var errEl = document.createElement('p');
    errEl.className = 'elp-err'; errEl.hidden = true; errEl.setAttribute('role', 'alert');
    root.appendChild(errEl);
    function busy(btn, on) {
      if (!btn) { return; }
      if (on) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
      else { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); }
      var sp = btn.querySelector('.loading__spinner'); if (sp) { sp.classList.toggle('hidden', !on); }
      var db = dock.querySelector('.elp-dock-btn'); db.disabled = !!on; db.classList.toggle('is-busy', !!on);
    }
    function post(items) {
      var rt = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      return fetch(rt + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.text().then(function (t) { var d = {}; try { d = JSON.parse(t); } catch (e) {} return { ok: r.ok, status: r.status, d: d }; }); })
        .catch(function (e) { return { ok: false, status: 0, d: { description: String(e && e.message || e) } }; });
    }
    function report(what, detail) { try { if (window.clarity) { window.clarity('event', what); window.clarity('set', 'elp_err', String(detail || '').slice(0, 120)); } } catch (e) {} }
    var adding = false;
    var isAr = (root.getAttribute('dir') || '') === 'rtl';
    /* one retry, then each line on its own; if ANY line got in, open the cart / checkout (it lists exactly what is
       there); only when nothing could be added, a short message inside the picker. Also used by the Elvara Care
       add-on so a plan + set gets the same safety. */
    function addRobust(items, btn, dest) {
      adding = true; errEl.hidden = true;
      var rt = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      busy(btn, true);
      function done() { window.location.href = rt + (dest || 'cart'); }
      function fail(res) {
        adding = false; busy(btn, false);
        report('elp_add_fail', (res && res.status) + ' ' + (res && res.d && (res.d.description || res.d.message) || ''));
        var net = !res || !res.status;
        errEl.textContent = net
          ? (isAr ? 'مشكلة في الاتصال — تأكد من الإنترنت واضغط مرة أخرى.' : 'Connection problem — check your internet and tap again.')
          : (isAr ? 'تعذّرت الإضافة — اضغط مرة أخرى.' : 'Could not add to cart — please tap again.') + (res.d && res.d.description ? ' (' + res.d.description + ')' : '');
        errEl.hidden = false;
        errEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      return post(items).then(function (r1) {
        if (r1.ok) { return done(); }
        return new Promise(function (ok) { setTimeout(ok, 700); }).then(function () { return post(items); }).then(function (r2) {
          if (r2.ok) { return done(); }
          report('elp_add_retry_fail', r2.status + ' ' + (r2.d.description || ''));
          var got = 0, last = r2, i = 0;
          function next() {
            if (i >= items.length) { if (got > 0) { return done(); } return fail(last); }
            var it = items[i++];
            return post([it]).then(function (r) { if (r.ok) { got++; } else { last = r; } return next(); });
          }
          return next();
        });
      });
    }
    window.elpAddRobust = function (items, btn, dest) { if (adding) { return; } return addRobust(items, btn, dest); };
    /* Add to cart: the whole set as separate lines, then the cart (which shows the discount applied).
       2026-10-17: a friend's phone got "could not add everything" and the page then looked frozen. Now: one retry,
       then each line on its own; if ANY line got in, go to the cart (it lists exactly what is there); only if
       nothing could be added is a message shown — inside the picker, never a blocking alert. */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) { return; }
      var idInput = form.querySelector('[name="id"]');
      var box = root.closest('.product__info-container');
      if (!idInput || order.length === 0) { return; }
      if (box ? !box.contains(form) : idInput.value !== anchorVid) { return; }
      e.preventDefault(); e.stopImmediatePropagation();
      if (adding) { return; }
      adding = true; errEl.hidden = true;
      var items = [{ id: parseInt(idInput.value, 10), quantity: qtyFor(form) }].concat(extraItems());
      addRobust(items, form.querySelector('[name="add"]'), 'cart');
    }, true);
    /* Back from the cart: Safari / Chrome restore this page from memory with the button still spinning, which looks
       like a frozen page. Reset it whenever the page is shown again. */
    window.addEventListener('pageshow', function () {
      adding = false;
      busy(document.querySelector('.product__info-container product-form [name="add"]'), false);
    });

    /* A size change (Garmin) re-renders the price and the buy buttons: read the new price, re-attach, re-observe. */
    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.closest || !e.target.closest('variant-selects, variant-radios')) { return; }
      setTimeout(function () {
        try { var sv = (root.closest('.product__info-container') || document).querySelector('[data-selected-variant]'); if (sv) { var v = JSON.parse(sv.textContent); if (v && v.price) { anchorPrice = v.price; } } } catch (err) {}
        refresh(); watchAdd();
      }, 600);
    });

    /* Phones: the chat bubble steps aside while the picker is on screen (it sat on the last swatch column). */
    var addIO = null, watched = null;
    function watchAdd() {
      if (!('IntersectionObserver' in window)) { return; }
      var ra = document.querySelector('.product__info-container product-form [name="add"]');
      if (!ra || ra === watched) { return; }
      if (addIO) { addIO.disconnect(); }
      watched = ra;
      addIO = new IntersectionObserver(function (en) { addVisible = en[0].isIntersecting; dockShow(); }, { threshold: 0.6 });
      addIO.observe(ra);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var v = en[0].isIntersecting;
        if (v !== inView) { inView = v; document.documentElement.classList.toggle('elp-in-view', inView); }
      }, { threshold: 0 }).observe(root);
      watchAdd();
    }
    document.addEventListener('elv:tier', function () { refresh(); });
    refresh();
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('.elp'), init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
